const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Save system configuration
 * @param {object} data - Complete system config data
 */
export const saveSystemConfig = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/system-config`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to save system configuration');
    }

    return await response.json();
  } catch (error) {
    console.error('Error saving system config:', error);
    throw error;
  }
};

/**
 * Get system configuration by connection ID
 * @param {number} connectionId 
 */
export const getSystemConfig = async (connectionId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/system-config/${connectionId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const jsonData = await response.json();
    //console.log("System config data:", jsonData);
    
    return jsonData;
    
  } catch (error) {
    console.error("Error fetching system config:", error);
    throw error;
  }
};


//get admin system config

export const getAdminSystemConfig = async (connectionId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin-system-config/${connectionId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const jsonData = await response.json();
    //console.log("System config data:", jsonData);
    
    return jsonData;
    
  } catch (error) {
    console.error("Error fetching system config:", error);
    throw error;
  }
};
/**
 * Update system configuration
 * @param {number} id - Config ID
 * @param {object} data - Updated config data
 */
export const updateSystemConfig = async (id, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/system-config/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const jsonData = await response.json();
    //console.log("Update response:", jsonData);
    
    return jsonData;
    
  } catch (error) {
    console.error("Error updating system config:", error);
    throw error;
  }
};

/**
 * Delete system configuration
 * @param {number} id - Config ID
 */
export const deleteSystemConfig = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/system-config/${id}`, {
      method: 'DELETE',
       'Authorization': `Bearer ${localStorage.getItem('authToken')}`
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    // For DELETE, often no content is returned
    if (response.status === 204) {
      return { success: true };
    }
    
    return await response.json();
    
  } catch (error) {
    console.error("Error deleting system config:", error);
    throw error;
  }
};
// Add this function to your existing systemConfigService.js
export const sendQuotationEmail = async (formData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/send-quotation-email`, {
      method: 'POST',
      headers: {
        // ❌ Don't set Content-Type manually
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      },
      body: formData, // ✅ This now works correctly
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to send email');
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error sending quotation email:', error);
    return {
      success: false,
      message: error.message || 'Failed to send email',
    };
  }
};

/**
 * Save contract notes (special conditions + cashback) for a connection
 * @param {number} connectionId
 * @param {{specialConditions: string, cashback: string|number}} notes
 */
// services/systemConfigService.js
export const saveContractNotes = async (connectionId, notes) => {
  try {
    const response = await fetch(`${API_BASE_URL}/system-config/${connectionId}/contract-notes`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
      },
      body: JSON.stringify(notes), // { specialConditions, cashback }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to save contract notes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error saving contract notes:', error);
    throw error;
  }
};
